
import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { Client } from '@/models/Client';
import { formatPhoneNumber } from '@/utils/formatters';

interface ClientInfoProps {
  client: Client;
}

const ClientInfo: React.FC<ClientInfoProps> = ({ client }) => {
  const handlePhoneClick = (e: React.MouseEvent, phone: string) => {
    e.stopPropagation();
    window.location.href = `tel:${phone}`;
  };

  const handleEmailClick = (e: React.MouseEvent, email: string) => {
    e.stopPropagation();
    window.location.href = `mailto:${email}`;
  };

  if (!client.phone && !client.email) {
    return null;
  }

  return (
    <div className="space-y-2 text-xs text-muted-foreground">
      {client.phone && (
        <div className="flex items-center gap-2">
          <Phone className="h-3 w-3" />
          <button
            onClick={(e) => handlePhoneClick(e, client.phone!)}
            className="hover:underline text-primary text-left"
          >
            {formatPhoneNumber(client.phone)}
          </button>
        </div>
      )}
      {client.email && (
        <div className="flex items-center gap-2">
          <Mail className="h-3 w-3" />
          <button
            onClick={(e) => handleEmailClick(e, client.email!)}
            className="hover:underline text-primary text-left"
          >
            {client.email}
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientInfo;
